@if (isAuthRoute()) {
  <!-- Bare page (login) — no app chrome. -->
  <router-outlet></router-outlet>
} @else {
<div class="app" [class.studio-mode]="mode() === 'studio'" [class.persistency-mode]="mode() === 'persistency'">

  <!-- ============ TOPBAR ============ -->
  <div class="topbar">
    <div class="brand">
      <div class="brand-logo"><img src="sud-logo.jpg" alt="SUD Life · Sabse Pehle Life Insurance" /></div>
      <div class="brand-tag"><span class="small">AI Sales Platform · POC walkthrough v1.0</span></div>
    </div>
    <div class="topbar-right">
      <button class="audio-toggle" [class.muted]="audio.muted()" (click)="toggleAudio()" title="Toggle call audio playback">
        <span class="audio-icon">{{ audio.muted() ? '🔇' : '🔊' }}</span>
        <span>{{ audio.muted() ? 'Audio muted' : 'Audio on' }}</span>
      </button>
      <span class="pill">POC walkthrough</span>
      <span><span class="dot"></span>Cohort: 500 prospects · sandbox mode</span>
      @if (auth.user(); as u) {
        <div class="user-chip" title="{{ u.email }}">
          <span class="user-avatar">{{ u.name.charAt(0).toUpperCase() }}</span>
          <span class="user-meta">
            <span class="user-name">{{ u.name }}</span>
            <span class="user-role">{{ u.role }}</span>
          </span>
        </div>
        <button class="logout-btn" (click)="logout()" title="Sign out">Sign out</button>
      }
    </div>
  </div>

  <!-- ============ LEFT RAIL ============ -->
  <aside class="rail">
    <div class="rail-switch" [class.single]="!features.journey && !features.persistency">
      @if (features.journey) {
        <button [class.active]="mode() === 'journey'" (click)="switchMode('journey')">◷ Journey</button>
      }
      <button [class.active]="mode() === 'studio'" (click)="switchMode('studio')">◆ Agent Studio</button>
      @if (features.persistency) {
        <button [class.active]="mode() === 'persistency'" (click)="switchMode('persistency')">▤ Persistency</button>
      }
    </div>

    @if (mode() === 'journey') {
      <div class="rail-eyebrow">Live journey</div>
      <div class="rail-title">End-to-end<br />walkthrough</div>

      <div class="rail-prospect">
        <div class="label">Following</div>
        <div class="name">{{ prospectName() }}</div>
        <div class="meta">{{ prospectMeta() }}</div>
        <div class="meta mono" style="margin-top: 6px;">{{ journey.prospectId() }}</div>
      </div>

      <ul class="stages">
        @for (name of stageNames; track $index) {
          <li
            [class.current]="isCurrent($index + 1)"
            [class.done]="isDone($index + 1)"
            (click)="goToStage($index + 1)"
          >
            <span class="sn">{{ ($index + 1).toString().padStart(2, '0') }}</span>
            <span class="stage-name">{{ name }}</span>
            <span class="stage-tick">{{ isDone($index + 1) ? '✓' : '' }}</span>
          </li>
        }
      </ul>
    } @else {
      <div class="rail-eyebrow">Control plane</div>
      <div class="rail-title">Agent<br />Studio</div>
      <p class="rail-blurb">Build, govern and test AI calling agents — persona, knowledge banks, tools, guardrails and token budgets.</p>
    }

    <div class="rail-foot">
      <strong style="color: var(--ink);">POC scope</strong><br />
      Single product · two languages · 500 prospects · 6-week build · sandbox perimeter. Refer to the POC Proposal v1.0 for full details.
    </div>
  </aside>

  <!-- ============ MAIN ============ -->
  <main class="main">
    <router-outlet></router-outlet>
  </main>

  <!-- ============ FOOTER ============ -->
  <div class="foot">
    @if (mode() === 'journey') {
      <button class="btn ghost" [disabled]="journey.current() === 1" (click)="prev()">← Previous</button>
      <button class="btn gold" [disabled]="journey.current() === total" (click)="next()">Next stage →</button>
      <button class="btn ghost" style="margin-left: 8px;" (click)="reset()">Reset walkthrough</button>
      <div class="spacer"></div>
      <span class="progress-label">{{ progressLabel() }}</span>
      <div class="progress"><div class="bar" [style.width.%]="journey.progressPct()"></div></div>
    } @else {
      <div class="spacer"></div>
      <span class="studio-foot-note"><span class="dot"></span>
        {{ mode() === 'studio' ? 'Agent Studio · changes apply to the sandbox environment' : 'Persistency Intelligence · synthetic book' }}
      </span>
    }
  </div>
</div>
}

<!-- ============ TOAST (global) ============ -->
<div class="toast" [class.show]="toast.visible()"><span class="tick">✓</span><span [innerHTML]="toast.message()"></span></div>
